/**
 * Public map page chrome — header + description affordance.
 * Map fill uses flex-1; height comes from viewport/parent layout.
 * Title / nav hit use pageShell + chromeShell; horizontal padding matches px-page-x.
 */

import { chromeShell } from "./chromeShell";
import { pageShell } from "./pageShell";

export const publicMapShell = {
    body: "flex flex-col bg-bg-primary",
    header:
        "z-10 box-border flex w-full shrink-0 flex-col items-center justify-between border-0 border-b border-solid border-border bg-surface px-page-x py-0.5 text-text-primary shadow-none bp-lg:flex-row bp-lg:items-center",
    headerContent: "flex w-full items-center justify-between gap-3 bp-lg:gap-4",
    headerLeft: "flex-1",
    title: pageShell.titleText,
    descriptionButton: `${chromeShell.navHit} border-none bg-transparent p-0 text-center hover:bg-accent-10`,
    descriptionIcon: `material-symbols-outlined ${chromeShell.navIcon} text-text-muted group-hover:text-accent group-focus-within:text-accent`,
    descriptionText: `${chromeShell.navLabel} text-text-primary group-hover:text-accent group-focus-within:text-accent`,
    mapContainer: "relative flex-1",
};
